// the Pangolin Default token list lives here
export const AEB_TOKENLIST = 'https://raw.githubusercontent.com/pangolindex/tokenlists/main/aeb.tokenlist.json'

export const PANCAKE_LIST = 'https://tokens.pancakeswap.finance/pancakeswap-extended.json'

export const DEFAULT_TOKEN_LISTS_SELECTED: string[] = [PANCAKE_LIST]

export const DEFAULT_TOKEN_LISTS: string[] = [PANCAKE_LIST, AEB_TOKENLIST]
